import { render } from "./UangMakanForm.vue?vue&type=template&id=30e968fe"
import script from "./UangMakanForm.vue?vue&type=script&lang=js"
export * from "./UangMakanForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__